export const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const subdomainMappingRegex = {
  ao_prod: /^https:\/\/(www\.)?claims\.ao-care\.com(\/|$)/,
  ao_uat: /^https?:\/\/(www\.)?ao\.bright-claims\.uat\.test\.athome\.domgentest\.cloud(\/|$)/,
  ao_dev: /^https?:\/\/(www\.)?ao\.bright-claims\.test\.test\.athome\.domgentest\.cloud(\/|$)/,
  hoover_prod: /^https:\/\/(www\.)?hoovercare\.com(\/|$)/,
  hoover_uat: /^https?:\/\/(www\.)?hoover\.bright-claims\.uat\.test\.athome\.domgentest\.cloud(\/|$)/,
  hoover_dev: /^https?:\/\/(www\.)?hoover\.bright-claims\.test\.test\.athome\.domgentest\.cloud(\/|$)/,
  sky_prod: /^https:\/\/(www\.)?skyprotect\.com(\/|$)/,
  sky_uat: /^https?:\/\/(www\.)?sky\.bright-claims\.uat\.test\.athome\.domgentest\.cloud(\/|$)/,
  sky_dev: /^https?:\/\/(www\.)?sky\.bright-claims\.test\.test\.athome\.domgentest\.cloud(\/|$)/,
  dg_prod: /^https?:\/\/(www\.)?bright-claims\.athome\.domesticandgeneral\.com(\/|$)/,
  dg_uat: /^https?:\/\/(www\.)?bright-claims\.uat\.test\.athome\.domgentest\.cloud(\/|$)/,
  dg_dev: /^https?:\/\/(www\.)?bright-claims\.test\.test\.athome\.domgentest\.cloud(\/|$)/,
  ao_cypress: /^http:\/\/localhost:4200\/.*[?&]cypress_client=ao/,
  dg_cypress: /^http:\/\/localhost:4200(\/|$)/,
};
